import { Input } from "@/frontend/shared/ui/Input";
import { Modal } from "@/frontend/shared/ui/Modal";
import { useState } from "react";
import styles from "./InviteFounderModal.module.scss";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { reportErrorToSentry } from "@/frontend/shared/lib/reportErrorToSentry/reportErrorToSentry";
import { AxiosError } from "axios";
import { snackbarConstructor } from "@/frontend/shared/ui/CustomNotifications/ui/Snackbar/snackbarConstructor";
import { postInviteFounder } from "../../model/postInviteFounder";

export function InviteFounderModal({ isOpen, onClose, id }: { isOpen: boolean; onClose: () => void; id: number }) {
  const [email, setEmail] = useState("");
  const [isInviteFounderLoading, setIsInviteFounderLoading] = useState(false);

  function onCloseModal() {
    onClose();
    setEmail("");
  }

  async function onInviteFounder() {
    if (email.length === 0) return snackbarConstructor("Email is too small", "error");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return snackbarConstructor("Email is not valid", "error");
    }
    try {
      setIsInviteFounderLoading(true);
      await postInviteFounder({ email, id });
      snackbarConstructor("Invitation sent", "normal");
      onCloseModal();
    } catch (err) {
      const axiosError = err as AxiosError<{ message: string }>;
      reportErrorToSentry(axiosError as AxiosError, "INVITE FOUNDER: /portfolio-companies/${id}/invite-founder");
      snackbarConstructor(axiosError?.response?.data.message || "Failed to send invitation", "error");
    } finally {
      setIsInviteFounderLoading(false);
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onCloseModal} title="Invite Founders" className={styles.modal}>
      <div className={styles.container}>
        <Input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          inputSize="small"
          placeholder="Email"
          className={styles.websiteInput}
        />
        <NormalButton
          size="medium"
          onClick={onInviteFounder}
          isSubmitting={isInviteFounderLoading}
          className={styles.inviteButton}
        >
          Invite
        </NormalButton>
      </div>
    </Modal>
  );
}
